import { FC, SVGProps } from 'react'

export const Close: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.7257 19.7097C19.36 20.0754 18.767 20.0754 18.4013 19.7097L12.008 13.3164L5.5987 19.7257C5.23297 20.0914 4.64002 20.0914 4.27429 19.7257C3.90857 19.36 3.90857 18.767 4.27429 18.4013L10.6836 11.992L4.29032 5.5987C3.92459 5.23298 3.92459 4.64002 4.29032 4.27429C4.65604 3.90857 5.249 3.90857 5.61473 4.27429L12.008 10.6676L18.3853 4.29033C18.751 3.9246 19.344 3.9246 19.7097 4.29033C20.0754 4.65605 20.0754 5.24901 19.7097 5.61473L13.3324 11.992L19.7257 18.3853C20.0914 18.751 20.0914 19.3439 19.7257 19.7097Z"
			fill="currentColor"
		/>
	</svg>
)
